import DFDropDownList from "app/widgets/DFDropDownList/DFDropDownList";
import loginProps from "common/managers/loginProps";

/**
 * Extension of drop down list that checks a system property to determine whether filtering should be turned on.
 */
const PossiblyFilterableDropDownList = DFDropDownList.extend({

    options: {
        name: "PossiblyFilterableDropDownList",
        filterType: "contains" // maps to Kendo's filter property
    },

    init: function(element, options) {

        // if the system property to allow filtering is turned on, configure filter in the options
        if (loginProps.get().allowFilterableDropDownLists) {
            options.filter = options.filterType || "contains";
        }

        DFDropDownList.fn.init.apply(this, arguments);
    }
});

kendo.ui.plugin(PossiblyFilterableDropDownList);
export default PossiblyFilterableDropDownList;
